import { useMap } from "react-leaflet";
import IconLocationMap from "../SvgIcon/IconLocationMap";

function LocateButton({ lastPos }) {
  const map = useMap();

  const handleLocate = () => {
    if (!lastPos) return;
    map.flyTo(lastPos, 16, { duration: 1.5 });
  };

  return (
    <div className="map-control-wrapper">
      <div className="navigate-btn" onClick={handleLocate}>
        <IconLocationMap />
      </div>
    </div>
  );
}

export default LocateButton;